import React from "react";
import { Dropdown, Image } from "react-bootstrap";

export function UserMenu({ userName, userMail, onLogout }) {
    const avatarUrl = `https://ui-avatars.com/api/?name=${encodeURIComponent(userName)}&background=random`;

    return (
        <Dropdown align="end">
            <Dropdown.Toggle
                variant="light"
                id="dropdown-user-menu"
                as="div" // <- Ключевой момент: используем div, а не button
                className="d-flex align-items-center"
                style={{ cursor: "pointer" }}
            >
                <Image
                    src={avatarUrl}
                    roundedCircle
                    width={32}
                    height={32}
                    className="me-2"
                />
                <span className="user-name">{userName}</span>
            </Dropdown.Toggle>

            <Dropdown.Menu>
                <Dropdown.Header>{userMail}</Dropdown.Header>
                <Dropdown.Divider />
                <Dropdown.Item onClick={onLogout}>Logout</Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
}
